export enum UpdatedRemovalFeature {
  CART = "CART",
  WISHLIST = "WISHLIST",
  PRODUCT = "PRODUCT",
  VARIANT = "VARIANT",
}

export const UpdatedRemovalMessages: Record<UpdatedRemovalFeature, string> = {
  [UpdatedRemovalFeature.CART]:
    "Your cart data has been updated. Some variants or products may have been removed as they are no longer available.",
  [UpdatedRemovalFeature.WISHLIST]:
    "Your wishlist has been updated. Some items may have been removed as they are no longer available.",
  [UpdatedRemovalFeature.PRODUCT]:
    "The product you were viewing has been updated or removed as it is no longer available.",
  [UpdatedRemovalFeature.VARIANT]:
    "Some product variants you selected are no longer available and have been removed.",
};
